import { fromJS } from 'immutable';

export function request(state) {
    return state.set('createRelatedContingencyLabel', fromJS({
        status: 'IN_PROGRESS'
    }));
}

export function finish(state, { data }) {
    return state.set('createRelatedContingencyLabel', fromJS({
        status: 'FINISHED',
        data
    }));
}

export function error(state) {
    return state.set('createRelatedContingencyLabel', fromJS({
        status: 'ERROR'
    }));
}
